//The Vue build version to load with the `import` command
//(runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import axios from './api/vue-axios';
import store from './store';
import helpers from './helpers';
import vuetify from './plugins/vuetify';
import sdkInstances from './consts/sdk-instances';
import InstantSearch from 'vue-instantsearch';
import SessionUser from './helpers/session-user';
import VueMeta from 'vue-meta';

Vue.use(InstantSearch);
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
});
Vue.config.productionTip = false;
Vue.prototype.$sdkInstances = sdkInstances;

SessionUser._saveInitialStateInfo(store.state);

/*eslint-disable no-new */
new Vue({
  router,
  axios,
  store,
  helpers,
  vuetify,
  render: h => h(App)
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js